
export default function ResourcesSection() {
  const resources = [
    {
      title: 'Study Guides & Materials',
      description: 'Comprehensive study resources for both pharmacy and veterinary curricula',
      icon: 'ri-book-2-line',
      items: ['NAPLEX Preparation', 'NAVLE Study Materials', 'Clinical Case Studies', 'Pharmacology Resources']
    },
    {
      title: 'Career Resources',
      description: 'Tools and guidance for launching your professional career',
      icon: 'ri-briefcase-2-line', 
      items: ['Resume Templates', 'Interview Preparation', 'Job Board Access', 'Mentorship Program']
    },
    {
      title: 'Research Opportunities',
      description: 'Engage in cutting-edge research projects and publications',
      icon: 'ri-microscope-line',
      items: ['Research Grants', 'Publication Opportunities', 'Conference Presentations', 'Lab Partnerships']
    },
    {
      title: 'Wellness & Support',
      description: 'Mental health and academic support resources',
      icon: 'ri-heart-3-line',
      items: ['Counseling Services', 'Stress Management', 'Peer Support Groups', 'Work-Life Balance']
    },
    {
      title: 'Professional Development',
      description: 'Skills development for future healthcare leaders',
      icon: 'ri-user-star-line',
      items: ['Leadership Training', 'Communication Skills', 'Ethics Workshops', 'Continuing Education']
    },
    {
      title: 'Advocacy Training',
      description: 'Learn to advocate for your profession and patients',
      icon: 'ri-megaphone-line',
      items: ['Policy Analysis', 'Government Relations', 'Public Speaking', 'Legislative Process']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Student Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access comprehensive resources designed to support your academic success and professional development in pharmacy and veterinary medicine
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {resources.map((resource, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className={`${resource.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {resource.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {resource.description}
              </p>
              <ul className="space-y-2">
                {resource.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
            Access Student Portal
          </button>
        </div>
      </div>
    </section>
  );
}
